import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as o, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconJiraServiceDesk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], m = /* @__PURE__ */ e("path", {
  d: "m10.25 14.007-5.408-.034a.848.848 0 0 1-.674-1.355L12.118 2a5.707 5.707 0 0 1 1.154 7.983l-3.022 4.024Z",
  fill: "#2684FF"
}, null, -1), f = ["id"], p = /* @__PURE__ */ e("stop", { "stop-color": "#0052CC" }, null, -1), h = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#2684FF"
}, null, -1), g = [
  p,
  h
];
function S(a, I, s, v, b, t) {
  return o(), n("svg", {
    "aria-label": s.ariaLabel,
    class: d([t.iconSizeClass, "d-icon d-icon--jira-service-desk"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Jira Service Desk",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      d: "m13.322 9.894 5.441.034a.848.848 0 0 1 .674 1.358L11.407 22a5.707 5.707 0 0 1-1.155-7.983l3.07-4.123Z",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, u),
    m,
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "13.109",
        y1: "10.695",
        x2: "15.395",
        y2: "17.607",
        gradientUnits: "userSpaceOnUse"
      }, g, 8, f)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ l(c, [["render", S]]);
export {
  w as default
};
//# sourceMappingURL=jira-service-desk.js.map
